import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Search_component_overview extends PureComponent {
  render() {
    return (
      <div className="row" id="search_component_overview">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Search Component Overview</h2>
              <p>
                Search components allow for results to be displayed on a search,
                record, dashboard, or report page. There are two main types of
                search components; results and filters. The result component is
                the display or renders component, which will show the list of
                results with the applied filters. The filter components allow
                you to filter and refine your results. Results and filters are
                linked by a property called “search_group”. “search_group” gives
                you the ability to run multiple filtered search results on one
                page without filters conflicting.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="hidden-sm-xs col-md-6 darkCol">
          <div className="contentDark"></div>
        </div>
      </div>
    );
  }
}

export default Search_component_overview;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Search_component_overview.js